import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Pilih Asal Terminal", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Tujuan Terminal", -1)
const _hoisted_6 = { class: "ml-6" }
const _hoisted_7 = { class: "list-disc" }
const _hoisted_8 = { class: "container-btn-action" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Form, {
      onSubmit: $setup.onSubmit,
      "validation-schema": _ctx.schema,
      "initial-values": $setup.initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_v_select, {
            autofocus: false,
            class: _normalizeClass(`select-primary ${errors.origin ? 'select-invalid' : ''}`),
            modelValue: values.origin,
            "onUpdate:modelValue": ($event: any) => ((values.origin) = $event),
            options: $setup.dataOption,
            "onOption:selecting": (val) => {
            setFieldValue('origin', val)
            $setup.getDestination(val)
          },
            placeholder: "Pilih rute",
            clearable: false,
            label: $setup.dataOption.label
          }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options", "onOption:selecting", "label"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(errors.origin), 1)
        ]),
        ($setup.dataDestinationTemp.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataDestinationTemp, (data) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: data.TerminalId,
                      class: "font-bold"
                    }, _toDisplayString(data.Name), 1))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "initial-values"])
  ]))
}